import { FsAssetSource } from './FsAssetSource.js';

/**
 * Build an http handler that serves ONLY the `client/` subtree of an assets
 * root — used by `WebClientServer`'s `GET /assets/<rel>` route. `server/`
 * assets and any traversal attempt always 404; nothing under `server/` is
 * ever reachable from the browser through this handler.
 */
export function makeAssetHttpHandler(root: string) {
  const src = new FsAssetSource(root);
  return async (rel: string): Promise<{ status: number; bytes?: Uint8Array; mimeType?: string }> => {
    // Only client/ is ever served to the browser; reject server/ and traversal.
    if (!rel.startsWith('client/') || rel.includes('..') || rel.includes('\\')) {
      return { status: 404 };
    }
    try {
      const la = await src.load(rel);
      return { status: 200, bytes: la.bytes, mimeType: la.mimeType };
    } catch {
      return { status: 404 };
    }
  };
}
